import axios from "axios";
import * as r from 'constants/routes';

export const fetchDocument = async (query) => {
    let retour = await axios.get(`${r.DOCUMENT}${query}`, {
        headers: {
            'x-applicat-apikey': process.env.REACT_APP_API_KEY
        },
        responseType: 'blob'
    }).then(res => {
        return res;
    });
    return retour;
};